import React from 'react';
import { Route, BrowserRouter, StaticRouter } from 'react-router-dom';
import { BranchesOverview } from './pages/BranchOverviewPage';
import { EmployeeDetails } from './pages/EmployeePage';
import { Branch } from './pages/BranchPage';
import { theme, GlobalStyle } from '@wco/toolkit';
import { ThemeProvider } from 'styled-components';
import appConfig from './config';

type AppProps = {
  baseUrl: string | undefined;
  headerText: string;
  searchHeaderText: string;
  showMobile: boolean;
  showFax: boolean;
  branchOverviewHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  branchHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  employeeHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  employeeBranchHeadlineSize: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  nextRouter?: any;
  notFoundPage?: string;
};

export default function App(props: AppProps) {
  appConfig.showMobile = props.showMobile;
  appConfig.showFax = props.showFax;
  appConfig.notFoundPage = props.notFoundPage;
  appConfig.baseUrl = props.baseUrl;
  if (props.nextRouter) {
    appConfig.SSR = true;
    const context = {};

    return (
      <>
        <ThemeProvider theme={theme}>
          {appConfig.devMode && (
            <>
              <GlobalStyle />
            </>
          )}

          <StaticRouter
            location={props.nextRouter.asPath}
            basename={props.baseUrl}
            context={context}
          >
            <PageRoutes {...props} />
          </StaticRouter>
        </ThemeProvider>
      </>
    );
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        {appConfig.devMode && <GlobalStyle />}
        <BrowserRouter basename={props.baseUrl}>
          <PageRoutes {...props} />
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}

function PageRoutes(props: AppProps) {
  const headerText = props.headerText;
  const branchOverviewHeadlineSize = props.branchOverviewHeadlineSize;
  const branchHeadlineSize = props.branchHeadlineSize;
  const employeeHeadlineSize = props.employeeHeadlineSize;
  const employeeBranchHeadlineSize = props.employeeBranchHeadlineSize;
  const searchHeaderText = props.searchHeaderText;
  const nextRouter = props.nextRouter;
  return (
    <>
      <Route
        path="/"
        exact
        render={props => (
          <BranchesOverview
            {...props}
            nextRouter={nextRouter}
            branchOverviewHeadlineSize={branchOverviewHeadlineSize}
            searchHeaderText={searchHeaderText}
          ></BranchesOverview>
        )}
      ></Route>

      <Route
        path={`/:branchname`}
        exact
        render={props => (
          <Branch
            {...props}
            branchHeadlineSize={branchHeadlineSize}
            headerText={headerText}
            nextRouter={nextRouter}
          ></Branch>
        )}
      ></Route>

      <Route
        path={`/:branchname/:empid/:empname`}
        exact
        render={props => (
          <EmployeeDetails
            {...props}
            employeeHeadlineSize={employeeHeadlineSize}
            employeeBranchHeadlineSize={employeeBranchHeadlineSize}
            headerText={headerText}
            nextRouter={nextRouter}
          ></EmployeeDetails>
        )}
      ></Route>
    </>
  );
}
